import { Link } from 'react-router-dom';
import { useUserStore, useAuthStore } from '../stores/movieStore';

const HistoryPage = () => {
  const { history, clearHistory } = useUserStore();
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-4">请先登录</h2>
          <Link to="/login" className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl">去登录</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-white">观看历史</h1>
            <p className="text-gray-400 mt-2">共 {history.length} 条观看记录</p>
          </div>
          {history.length > 0 && (
            <button onClick={() => { if (confirm('确定清空历史？')) clearHistory(); }} className="px-4 py-2 text-red-400 hover:text-red-300 border border-red-500/50 rounded-xl transition-colors">
              清空历史
            </button>
          )}
        </div>

        {history.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-32 h-32 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-6xl">📜</span>
            </div>
            <h2 className="text-xl font-bold text-white mb-4">暂无观看记录</h2>
            <Link to="/" className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl">去观看</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-6">
            {history.map((item) => (
              <Link key={`${item.source}:${item.videoId}`} to={`/play/${item.videoId}?source=${item.sourceId}`} className="group">
                <div className="relative overflow-hidden rounded-2xl bg-slate-800/50 card-hover">
                  <div className="aspect-[2/3] overflow-hidden">
                    <img src={item.poster} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    <div className="absolute bottom-0 left-0 right-0 h-1 bg-slate-700">
                      <div className="h-full bg-blue-500" style={{ width: `${item.progress}%` }} />
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                        <svg className="w-6 h-6 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 px-1">
                  <h3 className="text-white font-medium text-sm line-clamp-1 group-hover:text-blue-400 transition-colors">{item.title}</h3>
                  <p className="text-gray-400 text-xs mt-1">{item.progress}% · {new Date(item.watchedAt).toLocaleDateString()}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoryPage;
